<template lang="pug">

.ui.menu.top-navigation(:class="{ expanded: isExpanded }")
    .item
        i(:class="isExpanded ? 'chevron left icon' : 'chevron right icon'" @click="$emit('toggle')" title="Menü umschalten")
    .item
        .ui.header
            .content {{ pageTitle }}
    .right.menu
        .ui.right.aligned.category.search.item
            .ui.icon.input
                input(type="text" placeholder="Schnellsuche...")
                i.search.link.icon

</template>

<script>
    export default {
        name: 'TopNavigation',

        props: {
            isExpanded: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            pageTitle() {
                const matched = this.$route.matched
                for (let i = matched.length - 1; i >= 0; i--) {
                    const title = matched[i].meta && matched[i].meta.title
                    if (!title) continue
                    if (typeof title === 'function') {
                        return title(this.$route, this.$store) || 'ZMÜK 2.0'
                    }
                    return title
                }
                return 'ZMÜK 2.0'
            }
        },

        emits: ['toggle']
    }
</script>

<style scoped>
    .top-navigation {
        position: fixed;
        top: 0;
        left: 69px;
        right: 0;
        z-index: 103;
        height: 50px;
        margin: 0 !important;
        border: none;
        border-bottom: 1px solid rgba(34, 36, 38, 0.1);
        border-radius: 0 !important;
        transition: left 0.3s ease;
        box-shadow: 10px 3px 8px rgba(34, 36, 38, 0.04);
    }

    .top-navigation.expanded {
        left: 279px;
    }

    .top-navigation .item::before {
        width: 0px;
    }

    .top-navigation .item > i.icon {
        cursor: pointer;
        margin: 0;
    }

    .top-navigation .ui.header .content {
        vertical-align: middle;
    }

    .top-navigation .item {
        padding: 0px 10px;
    }

    .top-navigation .item:first-child {
        padding-left: 12px;
        padding-right: 6px;
    }
</style>
